// Module
var code = "{{value}}";
// Exports
export default code;